import { AnyAction } from 'redux';
import {
  STREAM__WITH_OFFSET__INITIALIZE,
  STREAM__WITH_OFFSET__INSERT_ITEMS,
  STREAM__WITH_OFFSET__FETCH,
  STREAM__WITH_OFFSET__FETCH_SUCCESS,
  STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE,
  fetchPrevious,
  fetchPreviousSuccess,
  emptyStream,
  resetStream,
  fetchAllSuccess,
} from './actions';

import {
  InitializeAction,
  InsertItemsAction,
  FetchSuccessAction,
  FetchSuccessDedupeAction,
  OffsetStreamActionHandlers,
  OffsetStream,
} from './types';

import {
  handleInitAction,
  handleFetchAction,
  handleFetchSuccessAction,
  commonActionHandlers,
  handleFetchPreviousSuccessAction,
  handleEmptyStream,
  handleResetStream,
  handleFetchAllSuccessAction,
} from '../base/actionHandlers';
import {
  handleInsertItemsAction,
  handleDeleteItemsAction,
  dedupeFetchResults,
} from './actionHandlers';
import { STREAM__DELETE_ITEMS } from '../base/actions';
import { DeleteItemsAction } from '../base/types';
import { StreamType } from '../types';
import { defaultStreamState } from '../constants';

const actionHandlers: OffsetStreamActionHandlers = {
  [STREAM__WITH_OFFSET__INITIALIZE]: (
    streamState,
    action: InitializeAction
  ) => {
    return {
      ...handleInitAction(streamState, action),
      nextOffset: action.nextOffset,
      prevOffset: action.prevOffset,
    };
  },
  [STREAM__WITH_OFFSET__FETCH]: streamState => handleFetchAction(streamState),
  [STREAM__WITH_OFFSET__FETCH_SUCCESS]: (
    streamState,
    action: FetchSuccessAction
  ) => ({
    ...handleFetchSuccessAction(streamState, action),
    prevOffset: action.prevOffset,
    nextOffset: action.nextOffset,
  }),
  [STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE]: (
    streamState,
    action: FetchSuccessDedupeAction
  ) => dedupeFetchResults(streamState, action),
  [STREAM__WITH_OFFSET__INSERT_ITEMS]: (
    streamState,
    action: InsertItemsAction
  ) => handleInsertItemsAction(streamState, action),

  [fetchPrevious.toString()]: handleFetchAction,
  [fetchPreviousSuccess.toString()]: (
    streamState,
    action: ReturnType<typeof fetchPreviousSuccess>
  ) => ({
    ...handleFetchPreviousSuccessAction(streamState, action),
    prevOffset: action.payload.prevOffset,
  }),
  [fetchAllSuccess.toString()]: (
    streamState,
    action: ReturnType<typeof fetchAllSuccess>
  ) => ({
    ...handleFetchAllSuccessAction(streamState, action),
    prevOffset: undefined,
    nextOffset: undefined,
  }),
  [emptyStream.toString()]: (
    streamState,
    action: ReturnType<typeof emptyStream>
  ) => ({
    ...handleEmptyStream(streamState, action),
    nextOffset: undefined,
    prevOffset: undefined,
  }),
  [resetStream.toString()]: (
    streamState,
    action: ReturnType<typeof resetStream>
  ) => ({
    ...handleResetStream(streamState, action),
    nextOffset: 0,
    prevOffset: undefined,
  }),

  ...commonActionHandlers,
  // overrides
  [STREAM__DELETE_ITEMS]: (streamState, action: DeleteItemsAction) =>
    handleDeleteItemsAction(streamState, action),
};

const reducer = (
  streamState: OffsetStream = {
    ...defaultStreamState,
    streamType: StreamType.WITH_OFFSET,
  },
  action: AnyAction
) => {
  const handler = actionHandlers[action.type];
  return (handler && handler(streamState, action)) || streamState;
};

export default reducer;
